import { FloatingFormItem } from '@/components/_common';
import {
  DeleteWorkOrderItemRequest,
  WorkOrderItem,
  WorkOrderItemRemoveFormValues,
} from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import {
  Alert,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  Row,
} from 'antd';
import { useWorkorderDetailContext } from '@/components/Movements/WorkOrders/Details/WorkorderDetailProvider';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  item?: WorkOrderItem;
  onCallback: (params: DeleteWorkOrderItemRequest) => Promise<void>;
}

export default function WorkOrderRemoveItemModal({
  onCancel,
  item,
  onCallback,
  ...props
}: Props) {
  const [form] = Form.useForm<WorkOrderItemRemoveFormValues>();

  const {
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const isItemRejectedByCustomer = Form.useWatch(
    'isItemRejectedByCustomer',
    form,
  );

  function handleCancel() {
    form.resetFields();

    onCancel();
  }

  async function handleSubmit() {
    if (complement?.id && item) {
      const values = await form.validateFields();

      await onCallback({
        complementId: complement.id,
        workOrderItemId: item.id,
        isItemRejectedByCustomer: values.isItemRejectedByCustomer,
        itemRejectedReason: values.itemRejectedReason,
        hasPecaAi: !!item.pecaAiProductId,
      });

      handleCancel();
    }
  }

  return (
    <Modal
      title="Remover item do orçamento"
      onCancel={handleCancel}
      okText="Remover"
      okType="danger"
      onOk={handleSubmit}
      {...props}
    >
      <Form form={form}>
        <Row gutter={[12, 12]}>
          <Col span={24}>
            <Alert
              type="warning"
              message={`Deseja realmente remover o item ${item?.description} do orçamento?`}
            />
          </Col>
          {!!item?.benefitServiceCode && (
            <Col span={24}>
              <Alert
                type="warning"
                message="O benefício da apólice será removido do complemento e das configurações do Benefícios do segurado!"
              />
            </Col>
          )}

          {!item?.benefitServiceCode && (
            <Col span={24}>
              <Form.Item
                noStyle
                name="isItemRejectedByCustomer"
                initialValue={false}
                valuePropName="checked"
              >
                <Checkbox style={{ fontWeight: 'bold' }}>
                  Item recusado pelo Cliente?
                </Checkbox>
              </Form.Item>
            </Col>
          )}

          {isItemRejectedByCustomer && (
            <Col span={24}>
              <FloatingFormItem label="Motivo" name="itemRejectedReason">
                <Input.TextArea rows={6} maxLength={120} showCount />
              </FloatingFormItem>
            </Col>
          )}
        </Row>
      </Form>
    </Modal>
  );
}
